// Offscreen bitmaps are only worth their memory while a point-pick tool (Move/Copy/
// Rotate) is active: the scene itself is static there and only the cursor moves.
const MAX_GHOST_AREA_CANVASES = 4

// A cached bitmap is valid only while every input that shaped it is identical.
export function isSceneCacheValid(cache, key) {
  return !!cache
    && cache.key.length === key.length
    && key.every((v, i) => Object.is(v, cache.key[i]))
}

// Screen-space shift of a ghost rendered at the base point for a world delta.
export function ghostScreenOffset(dx, dy, scale) {
  return [Math.round(dx * scale), Math.round(-dy * scale)]
}

// Screen rect (canvas px) covering the ghost. Returns null when the ghost reaches past
// the canvas padded by one canvas size per side, or would need more than a few canvases
// of memory — cropping would lose geometry, so the caller draws entity by entity.
export function ghostBitmapRect(screenBounds, canvasW, canvasH) {
  if (!screenBounds) return null
  const x0 = Math.floor(screenBounds.minX) - 2
  const y0 = Math.floor(screenBounds.minY) - 2
  const x1 = Math.ceil(screenBounds.maxX) + 2
  const y1 = Math.ceil(screenBounds.maxY) + 2
  const w = x1 - x0, h = y1 - y0
  if (x0 < -canvasW || y0 < -canvasH || x1 > 2 * canvasW || y1 > 2 * canvasH) return null
  if (w <= 0 || h <= 0 || w * h > MAX_GHOST_AREA_CANVASES * canvasW * canvasH) return null
  return { x: x0, y: y0, w, h }
}
